import { CHANGE_LOCALE } from '../actions/actionTypes';

let locale = localStorage.getItem('locale') || (navigator.language || navigator.browserLanguage).substr(0, 2);
switch (locale) {
  case 'pt':
    locale = 'pt';
    break;
  default:
    locale = 'en';
}
localStorage.setItem('locale', locale);

function localeSelector(state = locale, action) {
  switch (action.type) {
    case CHANGE_LOCALE:
      return action.newLocale;
    default:
      return state;
  }
}

export default localeSelector;



/** WEBPACK FOOTER **
 ** ./src/reducers/localeSelector.js
 **/